var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signedIn)?_c('div',[_vm._t("default")],2):_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(!_vm.signedIn),expression:"!signedIn",modifiers:{"fullscreen":true}}]})}
var staticRenderFns = []

export { render, staticRenderFns }